import {FlistMappingData} from "@/ts/common";

export class FlistClient {
    async fetchFlistMappingData(): Promise<FlistMappingData> {
        const mappingData: FlistMappingData = await fetch('https://www.f-list.net/json/api/mapping-list.php')
            .then(value => value.json())
        return mappingData
    }
}